import { render } from "./form.vue?vue&type=template&id=593f11eb&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=593f11eb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593f11eb"]])

export default __exports__